export default "__VITE_ASSET__8a0644bd__"